<template>
  <qx-card-form title="订单信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="other" style="margin-left: 40px">
        <el-button type="primary" @click="calcOrderDetail">计算</el-button>
        <el-button type="primary" @click="showNavigationMap"
          >查看导航地图</el-button
        >
        <el-button type="primary" @click="autoSort">自动排序</el-button>
      </section>
      <section slot="orderTotalTimeUnit">
        <span
          class="primary cur"
          style="margin-right: 16px"
          @click="toTaskLineDetail"
          >查看</span
        >
      </section>
    </qx-custom-form>
    <TaskLineDetailDialog ref="taskLineDetailDialog" />
    <NavigationDialog ref="navigationDialog" />
  </qx-card-form>
</template>

<script>
import TaskLineDetailDialog from './components/taskLineDetailDialog';
import NavigationDialog from './components/navigationDialog/navigationDialog';
import { cityCustomerOrderCompute } from 'api/distribution';
export default {
  components: {
    TaskLineDetailDialog,
    NavigationDialog,
  },
  data () {
    return {
      rightTable: null,
      otherFormData: {
        computeInfo: null,
      },
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: '已选订单',
            value: 'addressCount',
            placeholder: ' ',
            type: 'input',
            readonly: true,
          },
          {
            label: '数量',
            value: 'totalGoodsCount',
            placeholder: ' ',
            type: 'input',
            readonly: true,
          },
          {
            label: '承运商里程',
            value: 'totalMileage',
            placeholder: ' ',
            type: 'input',
            readonly: true,
          },
          {
            label: '体积重量',
            value: 'volumeAndWeight',
            placeholder: ' ',
            type: 'input',
            readonly: true,
          },
          {
            label: '体积',
            value: 'totalProductVolume',
            type: 'input',
            readonly: true,
            hide: true,
          },
          {
            label: '重量',
            value: 'totalProductWeight',
            type: 'input',
            readonly: true,
            hide: true,
          },
          {
            label: '预计完成时间',
            value: 'orderTotalTime',
            placeholder: ' ',
            type: 'input',
            readonly: true,
          },
          {
            label: '',
            value: 'other',
            slot: true,
          },
        ],
      },
    };
  },
  methods: {
    getRightTable (form) {
      this.rightTable = form;
    },
    // 显示导航地图
    async showNavigationMap () {
      if (this.otherFormData.computeInfo) {
        this.$refs.navigationDialog.show(this.otherFormData.computeInfo);
      } else {
        await this.calcOrderDetail({ isAutoSort: true });
        if (this.otherFormData.computeInfo) {
          this.$refs.navigationDialog.show(this.otherFormData.computeInfo);
        }
      }
    },
    // 计算
    async calcOrderDetail ({ isAutoSort = false }) {
      const rightTableData = this.rightTable.getRightTableBoxData();
      if (rightTableData.length > 1) {
        let ids = [];
        rightTableData.forEach((item) => {
          ids.push(item.ccoId);
        });
        const res = await cityCustomerOrderCompute({
          ids: ids.join(),
          isAutoSort,
        });

        if (!res.failed) {
          const formData = {
            addressCount: res.addressCount || '',
            totalGoodsCount: res.totalGoodsCount || '',
            totalMileage: res.totalMileage || '',
            totalProductVolume: res.totalProductVolume || '',
            totalProductWeight: res.totalProductWeight || '',
            volumeAndWeight: (parseFloat(res.totalProductVolume) || '-') + '立方' + (parseFloat(res.totalProductWeight) || '-') + '吨',
            orderTotalTime: res.orderTotalTime || '',
          };
          this.$refs.baseForm.setVal('form', formData);

          // 自动排序
          if (isAutoSort) {
            const afterSortList = [];
            for (let i = 0; i < res.computeBeanList.length; i++) {
              if (res.computeBeanList[i].sortId === (i + 1)) {
                const item = rightTableData.find((info) => info.ccoId === res.computeBeanList[i].ccoId);
                afterSortList.push(item);
              }
            }
            this.rightTable.setRightTableBoxData(afterSortList);
          }

          // 下面是提交的时候需要的参数
          // 起点
          const ids = [];
          for (let item of res.computeBeanList) {
            ids.push(item.ccoId);
          }
          const computeBeanList = JSON.parse(JSON.stringify(res.computeBeanList));
          // 终点信息
          const desInfo = computeBeanList[computeBeanList.length - 1];
          // 途经点信息
          const subWayListInfo = computeBeanList.slice(0, computeBeanList.length - 1);
          subWayListInfo.map((item) => {
            item.desAddress = item.desAdderssDtl;
            item.navigatDesLocation = item.desAdderssDtl;
            item.desEand = item.desAddressNavigationLng;
            item.desNand = item.desAddressNavigationLat;
            item.arriveTime = 0;
            item.desProvince = item.desProvinceId;
            item.desCity = item.desCityId;
            item.desCounty = item.desDistrictId;
          });

          res.customerInfo = {
            orderType: '0',
            cityCustomerOrderIdListStr: ids.join(),
            customerName: rightTableData[0].customerName,
            customName: rightTableData[0].customerName,
            companyName: rightTableData[0].customerName,
            // 起点
            sourceProvince: res.sourceProvinceId,
            sourceCity: res.sourceCityId,
            sourceRegion: res.sourceDistrictId,
            sourceCounty: res.sourceDistrictId,
            source: res.sourceAdderssDtl,
            sourceAddress: res.sourceAdderssDtl,
            navigatSourceLocation: res.sourceAdderssDtl,
            sourceEand: res.sourceAddressNavigationLat,
            nand: res.sourceAddressNavigationLat,
            sourceNand: res.sourceAddressNavigationLng,
            eand: res.sourceAddressNavigationLng,
            // 终点
            desProvince: desInfo.desProvinceId,
            desCity: desInfo.desCityId,
            desRegion: desInfo.desDistrictId,
            desCounty: desInfo.desDistrictId,
            des: desInfo.desAdderssDtl,
            desAddress: desInfo.desAdderssDtl,
            navigatDesLocation: desInfo.desAdderssDtl,
            desEand: desInfo.desAddressNavigationLng,
            desNand: desInfo.desAddressNavigationLat,
            eandDes: desInfo.desAddressNavigationLng,
            nandDes: desInfo.desAddressNavigationLat,
            // 途经点
            subWayListStr: JSON.stringify(subWayListInfo),
            cmMileageNumber: parseFloat(res.totalMileage),
            mileageNumber: parseFloat(res.totalMileage),
            square: res.totalProductVolume,
            weight: res.totalProductWeight,
            // 发车时间
            dependTime: res.predictArriveDate,
          };

          this.otherFormData.computeInfo = res;
          this.$emit('getComputeInfo', this.otherFormData.computeInfo);
        }
      } else {
        this.$refs.baseForm.setVal('form', {});
        this.otherFormData.computeInfo = null;
        this.$message.warning('请选择2个或以上的订单');
      }
    },
    // 计算 + 自动排序
    async autoSort () {

      /**
      // 1、此功能放到第二阶段实现。
      // 2、计算方法
      // 1）计算所有点与装货点之间的导航距离，以距离最近的为第一个点。
      // 2）第二点的计算方法与计算第一个点类似，找余下的点中导航距离与第一个点最近的点作为第二个点。
      // 3）如此循环计算出最后一个点。
      */
      await this.calcOrderDetail({ isAutoSort: true });
    },
    // 任务线路详情
    toTaskLineDetail () {
      if (this.otherFormData.computeInfo) {
        this.$refs.taskLineDetailDialog.show(this.otherFormData.computeInfo);
      } else {
        this.$message.warning('请选择2个或以上的订单');
      }
    },

    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        let customerInfo = {};
        if (formData.computeInfo) {
          for (let name in formData.computeInfo.customerInfo) {
            if (formData.computeInfo.customerInfo[name] !== null || formData.computeInfo.customerInfo[name] !== undefined) {
              customerInfo[`customerInfo.${name}`] = formData.computeInfo.customerInfo[name];
            }
          }
        } else {
          this.$message.error('请加入需要提交的订单');
          customerInfo = null;
        }
        formData = customerInfo;
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.computeInfo = this.otherFormData.computeInfo || null;
      }
      return formData;
    },
    async init (data = {}) {
      this.otherFormData.computeInfo = data.computeInfo || null;
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.content-box {
  width: 240px;
}
</style>
